import { render, staticRenderFns } from "./addbandAccount.vue?vue&type=template&id=4c82fdbd&scoped=true"
import script from "./addbandAccount.vue?vue&type=script&lang=js"
export * from "./addbandAccount.vue?vue&type=script&lang=js"
import style0 from "./addbandAccount.vue?vue&type=style&index=0&id=4c82fdbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82fdbd",
  null
  
)

export default component.exports